import { render, staticRenderFns } from "./TunnelGroupsTable.vue?vue&type=template&id=cdc74ea2"
import script from "./TunnelGroupsTable.vue?vue&type=script&lang=ts"
export * from "./TunnelGroupsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports